import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import Pagination from 'react-js-pagination';
import { Modal, ModalBody, ModalHeader, Popover, PopoverBody, PopoverHeader, Table } from 'reactstrap';
import request from '../../../api/api';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import editImg from '../../../Images/icons/edit.svg'
import deleteImg from '../../../Images/icons/delete_cross.svg'
import { customStyles } from '../Course/Course';
import { SidebarData } from '../Sidebar/SidebarData';
import Select from 'react-select'
import toast from 'react-hot-toast';

const permissionOption = SidebarData?.map((list)=>{
    return {
        label:list.navItem,
        value:list.link
    }
})

 const validateSubadmin = (newSubadmin) => {
  const {
    employeeName,
    designation,
    permissions,
    email,
    password
  } = newSubadmin;

  if (!employeeName || employeeName.trim() === "") {
    toast.error("Employee name is required");
    return false;
  }

  if (!designation || designation.trim() === "") {
    toast.error("Designation is required");
    return false;
  }

  if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
    toast.error("Select at least one permission");
    return false;
  }

  if (!email || email.trim() === "") {
    toast.error("Email is required");
    return false;
  }

  // simple email format check
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    toast.error("Enter a valid email");
    return false;
  }

  if(!newSubadmin?._id){
    if (!password || password.trim() === "") {
    toast.error("Password is required");
    return false;
  }
  if (password.length < 6) {
    toast.error("Password must be at least 6 characters");
    return false;
  }
  }

  

  

  return true; // all good
};
function SubAdmin() {
  const navigate =useNavigate()
    const [pages, setpages] = useState("");
    const [activePage, setactivePage] = useState(1);
    const [currPage, setcurrPage] = useState(25);
    const [pageRangeDisplayed, setpageRangeDisplayed] = useState(4);
    const [subadminList, setSubadminList] = useState([])
    const [isAddAdmin,setIsAddAdmin] = useState(false)
    const [deleteId,setDeleteId] = useState("")
    const [newSubadmin,setNewSubadmin] = useState({
        username:"",
        email:"",
        password:"",
        roles:'',
        permissions:[]
    })
    const [tableOption, setTableOption] = useState({
        search: "",
        skip: 0,
        limit: 25,
        fromDate: "",
        toDate: "",
    });

     const handleChange=(e)=>{
        const {name,value}=e.target;
        setNewSubadmin({
            ...newSubadmin,
            [name]:value
        })
      }


    const getAllUserList = () => {
        request({
            url: "/subadmin/subadmin/list",
            method: "POST",
            data: tableOption,
        }).then((res) => {
            if (res.status === 1) {
                setSubadminList(res.response.result);
                setpages(res.response.fullcount);
                setcurrPage(res.response.length);
            } else if (res && +res.status === 0) {
                setSubadminList(res.response.result);
                setpages(res.response.fullcount);
                setcurrPage(res.response.length);
            }
        });
    };

    useEffect(() => {
        getAllUserList();
    }, [tableOption]);


     const search = debounce((value) => {
          setTableOption({ ...tableOption, search: value });
        }, 500);
    
        const paginate = (data) => {
          const limit = tableOption.limit;
      
          if (data) {
            setactivePage(data);
            setcurrPage(limit);
            setTableOption((state) => {
              return {
                ...state,
                page: {
                  current: data,
                  history: data,
                },
                skip: data * limit - limit,
              };
            });
          }
        };

        const addSubAdmin = () =>{
            setIsAddAdmin(!isAddAdmin)
        }

        const createNewSubamdin = () =>{
            const {employeeName,designation,permissions,email,password} = newSubadmin

            if(!validateSubadmin(newSubadmin)){
                return
            }

            request({
                url:'/subadmin/create/subadmin',
                method:'POST',
                data:newSubadmin
            }).then((res)=>{
                if(res.status===1){
                    toast.success("Subadmin Created")
                    setIsAddAdmin(!isAddAdmin)
                    setNewSubadmin({})
                    getAllUserList()
                }
                if(res.status===0){
                    toast.error(res.message)
                }
            }).catch((err)=>{
                console.log(err)
            })
        }

        const onDeleteSubAdmin =()=>{
            request({
                url:'/subadmin/subadmin/delete',
                method:"POST",
                data:{
                    subadminId:deleteId
                }
            }).then((res)=>{
                toast.success("Subadmin Deleted")
                getAllUserList()
                setDeleteId('')
            }).catch((err)=>{
                console.log(err)
            })
        }

        const updateSubadmin = ()=>{
            if(!validateSubadmin(newSubadmin)){
                return
            }
            request({
                url:'/subadmin/subadmin/update',
                method:'POST',
                data:{
                    ...newSubadmin,
                    subadminId:newSubadmin?._id
                }
            }).then((res)=>{
                toast.success("Updated Successfully")
                setIsAddAdmin(!isAddAdmin)
                setNewSubadmin({})
                getAllUserList()
            }).catch((err)=>{
                console.log(err)
            })
        }

  return (
    <Layout>
         <div className="mybookings-table-wrap mt-4">
        <div className='text-end mb-3'>
          <button className="add_blog_btn" onClick={()=>addSubAdmin()}> Add Subadmin</button>
        </div>
        <Table borderless className={`mybookings-table`}>
          <thead style={{ "--bg-color": "#f3f5ff" }}>
            <tr style={{ "--text-color": "#8d9eff" }}>
              <th>S.No</th>
              <th>Employee Name</th>
              <th>Email</th>
              <th>Designation</th>
              <th>Permissions</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {subadminList.length <= 0 ? (
              <tr className="text-center">
                <td colSpan={12}>
                  <h6>No records available</h6>
                </td>
              </tr>
            ) : (
              subadminList?.map((item, idx) => {
                return (
                  <tr
                    className="cursor-pointer"
                  >
                    <td>{tableOption.skip + idx + 1}</td>
                    <td>{item?.employeeName}</td>
                    <td>{item?.email}</td>
                    <td>{item?.designation}</td>
                    <td>
                      {permissionOption
                        ?.filter((li) => {
                          return item?.permissions?.includes(li.value);
                        })
                        .map((li) => li.label)
                        .join(",")}
                    </td>
                    <td
                      className="action-space"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span
                        className="text-warning"
                        onClick={() => {
                          setNewSubadmin(item);
                          setIsAddAdmin(!isAddAdmin);
                        }}
                      >
                        <img src={editImg} className="edit-icon" />
                      </span>
                      <span
                        id={`deleteId-sub-${idx}`}
                        className="action-btn"
                        onClick={() => setDeleteId(item._id)}
                      >
                        <img src={deleteImg} className="delete-icon" />
                      </span>
                      <Popover
                        placement="top"
                        isOpen={deleteId === item._id}
                        target={`deleteId-sub-${idx}`}
                        id={`deleteId-sub-${idx}`}
                      >
                        <PopoverHeader>Delete Confirmation</PopoverHeader>
                        <PopoverBody>
                          <h6
                            className="pb-2 text-muted"
                            style={{ lineHeight: "1.4" }}
                          >
                            Are you sure you want to permanently delete{" "}
                            <b className="text-dark">{item.title}</b>?
                          </h6>
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="confirm_btn"
                              title="Yes"
                              onClick={() => onDeleteSubAdmin()}
                            >
                              Delete
                            </button>
                            <button
                              className="cancel_btn"
                              type="button"
                              title="No"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId("");
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </PopoverBody>
                      </Popover>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
        <Pagination
          prevPageText={<i class="fa fa-angle-left" aria-hidden="true"></i>}
          nextPageText={<i class="fa fa-angle-right" aria-hidden="true"></i>}
          firstPageText={
            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
          }
          lastPageText={
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          }
          activePage={activePage}
          itemsCountPerPage={currPage}
          totalItemsCount={pages}
          pageRangeDisplayed={pageRangeDisplayed}
          onChange={paginate}
          itemClass="page-item"
          linkClass="page-link"
          activeLinkClass="subject"
        />


         
      </div>

       <Modal isOpen={isAddAdmin} toggle={()=>setIsAddAdmin(!isAddAdmin)} centered size='lg'>
        <ModalHeader toggle={()=>setIsAddAdmin(!isAddAdmin)}>{newSubadmin._id?'Edit':'Add'} Subadmin</ModalHeader>
        <ModalBody>
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <label className="font-semi code-red">Employee Name</label>
                <div>
                  <input
                    type="text"
                    className="login-input"
                    name="employeeName"
                    value={newSubadmin.employeeName}
                      onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-6">
                <label className="font-semi code-red">Email</label>
                <div>
                  <input
                    type="text"
                    className="login-input"
                    name="email"
                    value={newSubadmin.email}
                      onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-6">
                <label className="font-semi code-red">Password</label>
                <div>
                  <input
                    type="password"
                    className="login-input"
                    name="password"
                    value={newSubadmin.password}
                      onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-6">
                <label className="font-semi code-red">Designation</label>
                <div>
                  <input
                    type="text"
                    className="login-input"
                    name="designation"
                    value={newSubadmin.designation}
                      onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-12 mt-3">
                <label className="font-semi code-red">Select Permission</label>
                <div>
                  <Select 
                  isMulti
                  styles={customStyles}
                  options={permissionOption}
                  isClearable
                  value={permissionOption?.filter((li)=>{
                    return newSubadmin?.permissions?.some(op=> op === li.value)
                  })}
                  onChange={(e)=>setNewSubadmin({...newSubadmin,permissions:e.map((li)=>li.value)})}
                  />
                </div>
              </div>
              <div className='mt-4'>
                <button className='add_blog_btn' onClick={()=>newSubadmin?._id ? updateSubadmin() : createNewSubamdin()}>{newSubadmin?._id?"Update":"Submit"}</button>
              </div>
             
              
            </div>
            
          </div>
        </ModalBody>
      </Modal>

    </Layout>
  )
}

export default SubAdmin